<template>
    <div>
    <header>
            <div>
                <h2 class="header_side_eng">{{ recordtoshow.nameeng }}</h2>
                <h2 class="header_side_ch">{{ recordtoshow.namech }}</h2>
            </div>
            <div>
                <span class="header_side_idtag">{{ recordtoshow.recordid }}</span>
            </div>
    </header>
    <section class="mainbody">
                <!-- DATA SECTION: FIGURE -->
        <section class="data_module" v-if="recordtoshow.figure01">
            <div class="data_module_imagebox">
                <img :src="'figures/' + recordtoshow.figure01" />
                <div @click="openZoom(recordtoshow.figure01)" class="data_module_imagebox_zoom"></div>
            </div>
        </section> 
        <!-- DATA SECTION: FIGURE -->
        <section class="data_module" v-if="recordtoshow.figure02">
            <div class="data_module_imagebox">
                <img :src="'figures/' + recordtoshow.figure02"/>
                <div @click="openZoom(recordtoshow.figure02)" class="data_module_imagebox_zoom"></div>
            </div>
        </section>
        <!-- DATA SECTION: PARAGRAPH -->
        <section class="data_module" v-if="recordtoshow.type">
            <h4 class="data_title"><span class="data_title_ch">類別</span> <span class="data_title_eng">Category</span></h4>
            <p class="data_eng">{{ recordtoshow.type }}</p>
        </section>
        <!-- DATA SECTION: PARAGRAPH -->
        <section class="data_module" v-if="recordtoshow.definitioneng || recordtoshow.definitionch">
            <h4 class="data_title"><span class="data_title_ch">定義</span> <span class="data_title_eng">Definition</span></h4>
            <p class="data_eng" v-html="recordtoshow.definitioneng"></p>
            <p class="data_ch" v-html="recordtoshow.definitionch"></p>
        </section>
        <!-- DATA SECTION: PARAGRAPH -->
        <section class="data_module" v-if="recordtoshow.synonym">
            <h4 class="data_title"><span class="data_title_ch">同義詞</span> <span class="data_title_eng">Synonyms</span></h4>
            <p class="data_eng">{{ recordtoshow.synonym }}</p>
        </section>
        <!-- DATA SECTION: PARAGRAPH -->
        <section class="data_module" v-if="recordtoshow.note">
            <h4 class="data_title"><span class="data_title_ch">註解 </span> <span class="data_title_eng">Notes</span></h4>
            <p class="data_eng" v-html="recordtoshow.note"></p>
        </section>
        <!-- DATA SECTION: PARAGRAPH -->
        <section class="data_module" v-if="recordtoshow.footnote">
            <h4 class="data_title"><span class="data_title_ch">註腳 </span> <span class="data_title_eng">Footnotes</span></h4>
            <p class="data_eng" v-html="recordtoshow.footnote"></p>
        </section>
    </section>
    </div>
</template>

<script>
import store from '@/store'

export default {
    name: 'RecordConcept',
    props: {
        recordtoshow: Object
    },
    methods: {
        openZoom(figuretoopen) {
            store.commit('updateZoomOpened', true)
            store.commit('updateZoomFigure',figuretoopen)
        },
    }
}
</script>